import { rouletteApiGet } from './roulette-api';
import { mapPopup, mapPrize } from './roulette.mappers';
import type { ApiFetchRouletteDetailPort } from '~/handlers/ports/api-fetch-roulette-detail.port';
import type { RouletteDetail } from '~/types/roulette';

export class ApostatudoApiFetchRouletteDetailAdapter
  implements ApiFetchRouletteDetailPort
{
  async handle(slug: string): Promise<RouletteDetail> {
    const json = await rouletteApiGet(`/roulettes/${encodeURIComponent(slug)}`);

    return {
      slug: json.slug,
      description: json.description ?? '',
      terms: json.terms ?? '',
      ringCustom: json.ring_custom
        ? {
            glowColor: json.ring_custom.glow_color ?? undefined,
            borderColor: json.ring_custom.border_color ?? undefined,
            borderColorBottom:
              json.ring_custom.border_color_bottom ?? undefined,
            borderInnerColor: json.ring_custom.border_inner_color ?? undefined,
            buttonColor: json.ring_custom.button_color ?? undefined,
            buttonText: json.ring_custom.button_text ?? undefined,
          }
        : null,
      spinDurationMs: json.spin_duration_ms ?? undefined,
      availableSpins: json.available_spins ?? 0,
      nextSpinAvailableAt: json.next_spin_available_at ?? null,
      prizes: (json.prizes ?? []).map(mapPrize),
      losePopup: mapPopup(json.lose_popup),
    };
  }
}
